module.exports = new __parcel__URL__("whiteboards.caa514dd.gif").toString();